<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
  <li [ngbNavItem]="1">
    <a ngbNavLink translate>Signal Expressions</a>
    <ng-template ngbNavContent>
      <scitis-admin-trigger-signal-expression-table
        [gatewaySelected]="gatewaySelected"
        [isAdminOrHigher]="isAdminOrHigher"
        [triggerSignalExpressions]="triggerSignalExpressions"
        [signals]="signals"
        (updatedTriggerExpressions)="onUpdatedTriggerExpressions($event)"
        (deletedTriggerSignalExpression)="onDeleteTriggerSignalExpression($event)">
      </scitis-admin-trigger-signal-expression-table>
    </ng-template>
  </li>

  @if (onShowTimeExpressions()) {
    <li [ngbNavItem]="2">
      <a ngbNavLink translate>Time Expressions</a>
      <ng-template ngbNavContent>
        <scitis-admin-trigger-time-expression-table
          [isAdminOrHigher]="isAdminOrHigher"
          [triggerTimeExpressions]="triggerTimeExpressions"
          (updatedTriggerTimeExpressions)="onUpdatedTriggerTimeExpressions($event)"
          (deletedTriggerTimeExpression)="onDeleteTriggerTimeExpression($event)">
        </scitis-admin-trigger-time-expression-table>
      </ng-template>
    </li>
  }
</ul>

<div class="card card-tab-container">
  <div class="card-body" [ngbNavOutlet]="nav"></div>
</div>